import { TrlPillExpired } from './TrlPillExpired';

export { TrlPillExpired } from './TrlPillExpired';
export default TrlPillExpired;
